module.exports = __webpack_public_path__ + "static/media/bank.6782ecf0.atlas";